import { Component, Input } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Html5Entities } from 'html-entities/lib/html5-entities';
import { Hotel } from 'src/main/webapp/assets/models/iter.model';
import { getServiceNotes } from '../common/service-notes';

/**ToDo Documentazione */
@Component({
  selector: 'app-hotels',
  styleUrls: ['./hotels.component.scss'],
  templateUrl: './hotels.component.html'
})
export class HotelsComponent {
  @Input() public day: any;
  @Input() public showOptionlServices: any;
  @Input() public version: any;
  @Input() public noImageUrl: any;
  @Input() public defaultImage: any;
  @Input() public replaceShowDescriptionButtonWithNotes: boolean = false;
  @Input() public hideMedia: boolean = false;
  @Input() public serviceIcons: any;
  state: any = sessionStorage.getItem('state');
  public modal!: NgbModalRef;

  public getServiceIconPath(name: string): string | undefined {
    return this.serviceIcons ? this.serviceIcons[name] : undefined;
  }

  public getFilteredNotes(notes: any): any[] {
    return getServiceNotes(notes, this.state);
  }

  constructor(private readonly modalService: NgbModal) {
    
  }

  public getHotelImage(hotel: Hotel): string {
    if (hotel.image) {
      return hotel.image;
    } else if (this.noImageUrl) {
      return this.noImageUrl;
    } else {
      return 'assets/custom/' + sessionStorage.getItem('version') + '/images/logo_tour_operator.png';
    }
  }

  public getTest(text: string): string {
    return Html5Entities.decode(text);
  }

  public getHotelTelephones(telephone: string): string[] {
    return telephone ? telephone.split(',').map(number => number.trim()).filter(number => number.length > 0) : [];
  }

  public sanitizeTelephoneForLink(telephone: string): string {
    return telephone ? telephone.replace(/[^\d+]/g, '') : '';
  }

  handleImgError(ev: any){
    const source = ev.target as HTMLImageElement;
    const fallback = `assets/custom/${sessionStorage.getItem('version')}/images/logo_tour_operator.png`;
    source.src = this.noImageUrl || fallback;
  }

  public openModal(historyFeeModal: any){
    this.modal = this.modalService.open(historyFeeModal);
  }
} 
